import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { GameUpdateData } from "../model/data/GameUpdateData";
/**
 * CollectResponseData.ts
 */
export class CollectResponseData extends SolidifyableData {
    solidify() {
        super.solidify();
        if (this.isSuccess()) {
            this.solidifyGameUpdate();
        }
    }
    solidifyGameUpdate() {
        if (this.dataExists(this.data)) {
            this.gameUpdate = new GameUpdateData(this.data);
        }
    }
    getGameUpdate() {
        return this.gameUpdate;
    }
}
//# sourceMappingURL=CollectResponseData.js.map